import * as React from 'react';
import { useTranslation } from 'react-i18next';

import MoneyView from 'shared/components/MoneyView';
import { TransactionInfo } from 'components/PositionDetailsModal/components/TransactionInfo';
import { DateTime } from 'components/PositionDetailsModal/components/DateTime';

import { Investment_IdeaCategory } from '../../../../../__generated__/globalTypes';
import { Fees } from '../Fees';
import { QuantityAsset } from '../QuantityAsset';
import { IdeaPositionDetailsBuyFragment } from './__generated__/IdeaPositionDetailsBuyFragment';

interface Props {
  ticker: string | null;
  category?: Investment_IdeaCategory;
  transaction: IdeaPositionDetailsBuyFragment;
}

export const Buy: React.FC<Props> = ({ transaction, ticker, category }) => {
  const { t } = useTranslation();
  if (!transaction.amount || !transaction.netAmount || !transaction.quantity) {
    return null;
  }

  const amount = {
    ...transaction.amount,
    value: -transaction.amount.value,
  };

  const price = {
    ...transaction.amount,
    value: transaction.netAmount.value / transaction.quantity,
  };

  return (
    <TransactionInfo
      title={t('Buying')}
      items={[
        <QuantityAsset
          ticker={ticker}
          category={category}
          quantity={transaction.quantity}
          data-testid="quantity"
        />,
        <MoneyView cents data-testid="price">
          {price}
        </MoneyView>,
        <MoneyView cents data-testid="net-amount">
          {transaction.netAmount}
        </MoneyView>,
        <Fees transaction={transaction} />,
        <MoneyView cents data-testid="amount">
          {amount}
        </MoneyView>,
        <DateTime>{transaction.date}</DateTime>,
      ]}
      data-testid="buy"
    />
  );
};
